import { styled } from '@mui/material/styles';

import ReverseGradientIconTextButton from '../ReverseGradientIconTextButton';

export const Container = styled('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  position: 'absolute',
  top: '0',
  left: '0',
  right: '0',

  padding: '4rem 8rem',
});

export const RightContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '5rem',
});

export const TabButtonContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',

  columnGap: '8rem',

  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const TabButtonItemContainer = styled('div')({
  position: 'relative',
});

export const IconContainer = styled('div')({
  width: '2.4rem',
  height: '2.4rem',
  '& > svg': {
    width: '2.4rem',
    height: '2.4rem',
  },
});

export const StyledReverseGradientIconTextButton = styled(ReverseGradientIconTextButton)({
  width: '19rem',
});

export const GradientTooltipContainer = styled('div')({
  position: 'absolute',
  bottom: '-10rem',
  left: '50%',
  transform: 'translate(-50%, -50%)',
});

export const GradientTooltipBodyContainer = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  padding: '0 1.6rem 0 2rem',

  position: 'absolute',

  backgroundColor: 'transparent',

  whiteSpace: 'pre-wrap',

  top: '50%',
  right: '10%',
  transform: 'translate(10%, -35%)',

  color: theme.colors.base01,
}));

export const CloseIconButton = styled('button')(({ theme }) => ({
  width: '2.4rem',
  height: '2.4rem',

  backgroundColor: 'transparent',

  padding: '0',
  border: 'none',

  '& > svg': {
    width: '2.4rem',
    height: '2.4rem',
    '& > path': {
      fill: theme.colors.base02,
    },
  },

  '&:hover': {
    opacity: '0.8',
    cursor: 'pointer',
  },
}));
